import { produce } from "immer";
import Actions from "../actions";

const initialState = {
    couponCodes: {},
    selectedCouponCodeId:''
};


const couponCodes = produce((draft = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case Actions.GET_COUPON_CODES_LIST: {
      draft.couponCodes = payload?.couponCodes;
      break;
    }

    case Actions.SELECTED_COUPON_CODE_ID: {
      draft.selectedCouponCodeId = payload?.selectedCouponCodeId;
      break;
    }

    default: {
      break;
    }
  }
}, initialState);

export default couponCodes;
